// src/components/Hero.jsx
import React from 'react';
import profilePic from '../assets/profile.jpg'; // Put your photo here

export default function Hero() {
  return (
    <div className="hero">
      <img src={profilePic} alt="Nikhil Goyal" />
      <h1>I’m Nikhil Goyal</h1>
      <p>Undergraduate ML Researcher</p>
    </div>
  );
}
